<template>
  <div class="section-box__jelly">
    <svg
      version="1.1"
      id="Warstwa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 33.4 373.4"
      style="enable-background:new 0 0 373.4 373.4; display: none;"
      xml:space="preserve"
    >
      <g>
        <g>
          <defs>
            <path
              id="pentagon-path"
              d="M674.8,227.8L674.8,227.8c112.1,81.5,159,225.9,116.2,357.8c-42.9,131.8-165.7,221.1-304.3,221.1l0,0
				c-138.6,0-261.5-89.3-304.3-221.1c-42.8-131.8,4.1-276.2,116.2-357.8l0,0C410.8,146.3,562.6,146.3,674.8,227.8z"
            ></path>
          </defs>
          <clipPath id="SVGID_2_">
            <use xlink:href="#SVGID_1_" style="overflow:visible;"></use>
          </clipPath>
          <rect x="149.3" y="149.3" class="st0" width="374.8" height="374.8"></rect>
        </g>
      </g>
    </svg>

    <div class="jelly-container">
      <!-- Canvas to draw the jelly -->
      <canvas class="jelly-canvas"></canvas>
    </div>
  </div>
</template>

<script>
import test from "@/js/jelly.js"

export default {
  name: "Blob",
  data() {
    return {};
  },

  beforeMount: function() {
    this.blob();
    this.svg();
  },

  methods: {
    blob() {
      jQuery(document).ready(function() {
   
        (function() {
          /* Setup options */

          var options = {
            paths: "#pentagon-path", // Shape we want to draw
            pointsNumber: 35, // Number of points
            maxDistance: 20, // Max distance among points
            color: "white",
            // border: "rgba(255,255,255,1)",
            // borderWidth: -100,
            intensity: 0.95,
            mouseIncidence: 20,
            maxIncidence: 40,
            imageCentroid: false,
            centroid: ".centroid-text" // Element to move accordingly with the centroid of the shape
            // debug: true               // Uncomment this to see the points
          };

          /* Initializing jelly */

          var jelly = new Jelly(".jelly-canvas", options);

          /* Check hover item (shape) and update cursor */

          var container = document.querySelector(".jelly-container");
          var hoverIndex = -1;

          function checkHover() {
            // The `getHoverIndex` function will return the index of the shape being hovered, or -1
            hoverIndex = jelly.getHoverIndex();
            container.style.cursor = hoverIndex === -1 ? "default" : "pointer";
            window.requestAnimationFrame(checkHover);
          }
          window.requestAnimationFrame(checkHover);

          /* Drag and drop */

          // var startX,
          //   startY,
          //   dx,
          //   dy,
          //   endX = 0,
          //   endY = 0,
          //   x = 0,
          //   y = 0,
          //   lastX = 0,
          //   lastY = 0;
          var down = false;

          // This will be the max distance for shaking
          var shakeLimit = 5;

          // container.addEventListener("mousedown", function(e) {
          //   if (hoverIndex >= 0) {
          //     startX = e.clientX;
          //     startY = e.clientY;
          //     down = true;
          //   }
          // });

          // document.addEventListener("mousemove", function(e) {
          //   if (down) {
          //     x = e.clientX - startX;
          //     y = e.clientY - startY;
          //     container.style.transform =
          //       "translate(" + (endX + x) + "px, " + (endY + y) + "px)";

          //     dx = x - lastX;
          //     dy = y - lastY;
          //     if (dx > shakeLimit || dx < -shakeLimit)
          //       dx = dx < 0 ? -shakeLimit : shakeLimit;
          //     if (dy > shakeLimit || dy < -shakeLimit)
          //       dy = dy < 0 ? -shakeLimit : shakeLimit;

          //     // The `shake` function will "move" the half of the points (alternately) the distance defined
          //     jelly.shake({
          //       x: -dx,
          //       y: -dy
          //     });

          //     lastX = x;
          //     lastY = y;
          //   }
          // });

          // function mouseUp() {
          //   if (down) {
          //     down = false;
          //     endX += x;
          //     endY += y;
          //   }
          // }

          // document.addEventListener("mouseup", mouseUp);

          // document.addEventListener("mouseout", function(e) {
          //   if (e.target.nodeName == "HTML") {
          //     mouseUp();
          //   }
          // });
        })();
      });
    },

    svg() {
      jQuery(document).ready(function() {
        !function() {
          "use strict";

          function g() {}

          function i(a) {
            var b = {};
            return (
              (b.x = a.clientX - window.innerWidth / 2 || 0),
              (b.y = a.clientY - window.innerHeight / 2 || 0),
              (b.fi =
                Math.atan(0 === b.x ? 1 / 0 : -b.y / b.x) +
                (b.x < 0 ? Math.PI : -b.y < 0 ? 2 * Math.PI : 0)),
              (b.s = (45 * Math.sin(2 * b.fi)) / 100),
              (b.x /= 100),
              (b.y /= 100),
              (b.r =
                2 *
                (Math.sqrt(Math.pow(b.x, 2) + Math.pow(b.y, 2)) /
                  Math.sqrt(
                    Math.pow(window.innerWidth, 2) +
                      Math.pow(window.innerHeight, 2)
                  ))),
              b
            );
          }

          function j(a) {
            for (var b = {}, c = 0; c < e.length; c++)
              b[e[c]] = +a.getAttribute("data-speed-" + e[c]) || 0;
            return b;
          }

          function k(a, b) {
            var c = {};
            return (
              (c.x = a.x * b.x + "px"),
              (c.y = a.y * b.y + "px"),
              (c.scale = 1 + a.r * b.scale),
              (c.opacity = 1 - a.r * Math.abs(b.opacity)),
              (c.rotate = 100 * -a.s * a.r * b.rotate + "deg"),
              c
            );
          }

          function l(a, c) {
            if (b) (a.style.marginLeft = c.x), (a.style.marginTop = c.y);
            else {
              for (var d in f)
                f.hasOwnProperty(d) &&
                  (a.style[d] = [
                    f[d],
                    "(",
                    c.x + "," + c.y,
                    "translate" === f[d] ? "" : ",0",
                    ") scale(",
                    c.scale,
                    ") rotate(",
                    c.rotate,
                    ")"
                  ].join(""));
              (a.style.opacity = c.opacity), (a.style.MozOpacity = c.opacity);
            }
          }

          function m(a) {
            if (!d) {
              a = "touchmove" === a.type ? a.changedTouches[0] : a;
              for (var b, c, g, e = i(a), f = 0; f < h.length; f++)
                (g = h[f]), (b = j(g)), (c = k(e, b)), l(g, c);
            }
          }

          var a = document.body.getAttribute("data-anm");
          if (a) {
            var d,
              b =
                /MSIE.\d+\./gi.test(navigator.userAgent) &&
                +navigator.userAgent.replace(/.*MSIE.(\d+)\..*/gi, "$1") < 9,
              c =
                "ontouchstart" in window || "onmsgesturechange" in window
                  ? "touchmove"
                  : "mousemove",
              e = ["x", "y", "scale", "opacity", "rotate"],
              f = {
                webkitTransform: "translate3d",
                MozTransform: "translate3d",
                msTransform: "translate3d",
                OTransform: "translate",
                transform: "translate3d"
              },
              h = (g.elements = document.querySelectorAll(a));
            (g.on = function() {
              d = !1;
            }),
              (g.off = function() {
                d = !0;
              }),
              (g.toggle = function() {
                d = !d;
              }),
              m({}),
              window.addEventListener
                ? window.addEventListener(c, m, !1)
                : window.attachEvent("onmousemove", function() {
                    m.call(window, window.event);
                  }),
              "function" == typeof define && define.amd
                ? define([], function() {
                    return g;
                  })
                : "undefined" != typeof module && module.exports
                ? (module.exports = g)
                : (this.anm = g);
          }
        }.call(this);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/small-components/MainSectionBlob.vue